import * as React from "react";
import { CarouselSlide } from "../../../components/Carousel";
import { ArticleFeaturedCard } from "../../../molecules/ArticleFeaturedCard";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
export const ArticleCardSlide = ({ content, slideIndex, slideTotal, ...props }) => {
    const { action } = content;
    const classNames = action ? "clickable" : "";
    return (React.createElement(CarouselSlide, { className: classNames, ...props },
        React.createElement(AnalyticsProvider, { uiLocation: `slide[${slideIndex + 1}:${slideTotal}]` },
            React.createElement(ArticleFeaturedCard, { content: content }))));
};
//# sourceMappingURL=ArticleCardSlide.js.map